import {GameGroupFilterDefinitionBase} from "../game-group-filter-definition-base";
import {GAME_GROUP} from "../../../../../common/const/game_groups_consts";

export class SlotsFilterDefinition extends GameGroupFilterDefinitionBase {

    get id(): string {
        return "slots";
    }

    protected get gameGroupsIdsToFilterFor(): number[] {
        return [GAME_GROUP.VIDEO_SLOT, GAME_GROUP.SLOT];
    }

    get text(): string {
        return this.services.translation.translate('SLOT_GAMES');
    }

}